<template>
  <DrawerContainer
    ref="drawerContainer"
    :dialogShow="dialogShow"
    :dialog-width="'50%'"
    :title="title"
    :has-footer="!isDetail"
    @resetPopupData="dialogShow = false"
    @submitPopupData="submitForm"
  >
    <div class="order-detail custom-form">
      <div class="list-status">
        <div class="list-carInfo">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image
            >司机/车辆信息
          </div>
          <div class="list-box">
            <div class="list-bottom">
              <div class="list-bottom-box">
                <div class="bottom-box-name">司机姓名</div>
                <div class="bottom-box-value">{{ detail.username || "-" }}</div>
              </div>
              <div class="list-bottom-box list-bottom-box2">
                <div class="bottom-box-name">联系电话</div>
                <div class="bottom-box-value">{{ detail.phone || "-" }}</div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">所属机构</div>
                <div class="bottom-box-value">
                  <custom-tooltip :text="detail.companyName"></custom-tooltip>
                </div>
              </div>

              <div class="list-bottom-box">
                <div class="bottom-box-name">关联车队长</div>
                <div class="bottom-box-value">
                  {{ detail.vehicleLeaderName || "-" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">车牌号码</div>
                <div class="bottom-box-value">
                  {{ detail.carNumber || "-" }}
                </div>
              </div>
              <div class="list-bottom-box">
                <div class="bottom-box-name">GPS</div>
                <div class="bottom-box-value">
                  {{ detail.gpsId || "未绑定" }}
                </div>
              </div>
            </div>
          </div>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>缴费信息
          </div>
          <el-row>
            <el-col :span="12" class="list-label">
              <span class="label">管理费应缴/实缴：</span>
              <span class="value"
                >{{ detail.managementFeePayable }}元/{{
                  detail.managementFee
                }}元</span
              >
            </el-col>
            <el-col :span="12" class="list-label">
              <span class="label">GPS应缴/实缴：</span>
              <span class="value"
                >{{ detail.gpsFeePayable }}元/{{ detail.gpsFee }}元</span
              >
            </el-col>
            <el-col :span="12" class="list-label">
              <span class="label">保险费应缴/实缴：</span>
              <span class="value"
                >{{ detail.premiumPayable }}元/{{ detail.premium }}元</span
              >
            </el-col>
            <el-col :span="12" class="list-label">
              <span class="label">上线费应缴/实缴：</span>
              <span class="value"
                >{{ detail.onlineFeePayable }}元/{{ detail.onlineFee }}元</span
              >
            </el-col>
            <el-col :span="24" class="list-label" v-if="detail.remark">
              <div class="label">缴费备注：</div>
              <div class="value value-box">
                {{ detail.remark }}
              </div>
            </el-col>
          </el-row>
          <div
            class="title-box"
            v-if="detail.feeVouchers && detail.feeVouchers.length > 0"
          >
            <el-image :src="cheImage" class="title-label"></el-image>付款凭证
          </div>
          <div class="info-box">
            <div
              class="info-box-list"
              v-for="(item, index) in detail.feeVouchers"
              :key="index"
            >
              <el-image
                :src="getFileUrl(item.fileId)"
                class="info-img"
                :preview-src-list="[getFileUrl(item.fileId)]"
              ></el-image>
            </div>
          </div>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>审批结果
          </div>
          <div class="examine2-box" v-if="isDetail">
            <div class="list">
              <span class="label">审批结果：</span>
              <span class="value">{{
                getLocalLabel("onLineAuditStatus", detail.auditStatus)
              }}</span>
            </div>
            <div class="list">
              <span class="label">操作人：</span>
              <span class="value">{{ detail.auditUsername || "-" }}</span>
            </div>
            <div class="list">
              <span class="label">操作时间：</span>
              <span class="value">{{ detail.auditTime || "-" }}</span>
            </div>
            <div class="list">
              <span class="label">补缴金额：</span>
              <span
                class="value"
                v-if="detail.replenish || detail.replenish === 0"
                >{{ detail.replenish }}元</span
              >
            </div>
            <div class="list">
              <span class="label">备注：</span>
              <span class="value">{{ detail.auditRemark || "-" }}</span>
            </div>
          </div>
          <div class="examine-box" v-else>
            <el-form ref="form" :model="form" :rules="rules" inline>
              <el-form-item prop="auditPass">
                <el-radio-group v-model="form.auditPass">
                  <el-radio :label="true">通过</el-radio>
                  <el-radio :label="false">不通过，需补缴</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="补缴金额"
                prop="replenish"
                v-if="!form.auditPass"
                ><el-input
                  v-model="form.replenish"
                  style="width: 20%"
                  placeholder="请输入"
                >
                  <template slot="append">元</template>
                </el-input></el-form-item
              >
              <el-form-item prop="auditRemark">
                <el-input
                  type="textarea"
                  clearable
                  rows="5"
                  placeholder="请输入备注，备注信息将同步欠款"
                  v-model="form.auditRemark"
                  show-word-limit
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </DrawerContainer>
</template>
<script>
import DrawerContainer from "@/components/Drawer.vue";
import CustomTable from "@/components/CustomTable.vue";
import { auditData, detailInfo } from "./api";
import { getFileUrl } from "@/utils/tool";
import { getLocalLabel } from "@/utils/localDict";
import { validatePrice } from "@/utils/validate";
import CustomTooltipMultiple from "@/components/CustomTooltipMultiple.vue";
import CustomTooltip from "@/components/CustomTooltip.vue";
export default {
  name: "AddOrEdit",
  data() {
    return {
      loading: false,
      title: "详情",
      isDetail: false,
      detailImage: require("@/assets/imgs/bg.png"),
      cheImage: require("@/assets/imgs/title.png"),
      siJiImage: require("@/assets/imgs/siji.png"),
      dngDanImage: require("@/assets/imgs/dngdan.png"),
      dialogShow: false,
      stepData: [],
      tableData: [],
      tableColumn: [
        {
          label: "操作类型",
          prop: "type",
          align: "left",
          show: true,
        },
        {
          label: "操作时间",
          prop: "date",
          align: "left",
          show: true,
        },
        {
          label: "操作人",
          prop: "personal",
          align: "left",
          show: true,
        },
        {
          label: "操作结果",
          prop: "result",
          align: "left",
          show: true,
        },
      ],
      detail: {},
      form: {
        auditPass: true,
        auditRemark: "",
        driverFeeId: "",
        replenish: "",
      },
      rules: {
        auditRemark: [{ required: true, message: "备注不能为空" }],
        replenish: [
          { required: true, message: "补缴金额不能为空" },
          { validator: validatePrice, trigger: "blur" },
        ],
      },
    };
  },
  components: {
    CustomTooltipMultiple,
    CustomTooltip,
    CustomTable,
    DrawerContainer,
  },
  methods: {
    getLocalLabel,
    getFileUrl,
    init(title, isDetail, row) {
      this.isDetail = isDetail;
      this.title = title;
      this.form.driverFeeId = row.driverFeeId;
      this.getDetail(row.driverFeeId);
      this.dialogShow = true;
    },
    getDetail(driverFeeId) {
      detailInfo(driverFeeId).then((res) => {
        if (res.code === 200) {
          this.detail = res.data;
        }
      });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.drawerContainer.loading = true;
          auditData(this.form)
            .then((res) => {
              this.$refs.drawerContainer.loading = false;
              if (res.code === 200) {
                this.$message.success("审批成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogShow = false;
              }
            })
            .catch((e) => {
              this.$refs.drawerContainer.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.order-detail {
  overflow-x: hidden;
  padding: 0 0.16rem;
  box-sizing: border-box;
  .list-box {
    background: #f7fbff;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
    .list-bottom {
      width: 100%;
      display: flex;
      padding: 0.08rem 0;
      .list-bottom-box {
        width: 15%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        .list-image {
          width: 0.85rem;
          height: 0.5rem;
          border-radius: 0.05rem;
        }
        .bottom-box-name {
          color: #8c8c8c;
          font-size: 0.12rem;
          margin-bottom: 0.06rem;
        }
        .bottom-box-value {
          color: #434343;
          text-align: center;
          font-size: 0.14rem;
        }
      }
      .list-bottom-box1 {
        width: 25%;
      }
      .list-bottom-box2 {
        width: 20%;
      }
      .list-bottom-box::before {
        content: "";
        position: absolute;
        right: 0;
        top: 0.08rem;
        width: 0.01rem;
        height: 0.26rem;
        background-color: #dce5f5;
      }
      .list-bottom-box:nth-last-of-type(1)::before {
        display: none;
      }
    }
    .list-bottom2 {
      .list-bottom-box:nth-last-of-type(1):before,
      .list-bottom-box:nth-last-of-type(2):before,
      .list-bottom-box:nth-last-of-type(3):before,
      .list-bottom-box:nth-last-of-type(4):before {
        display: none;
      }
    }
  }
  .list-status {
    display: flex;
    .title-box {
      padding: 0.2rem 0 0;
      .title-label {
        width: 0.08rem;
        height: 0.08rem;
        margin-right: 0.06rem;
      }
    }
    .list-step {
      width: 25%;
    }
    .list-carInfo {
      width: 100%;
    }
    .list-label {
      padding: 0.1rem 0;
    }
    //.list-step-box {
    //  display: flex;
    //  flex-direction: column;
    //  padding: 0 0.3rem 0 0.5rem;
    //  box-sizing: border-box;
    //  .step-list {
    //    border-radius: 0.1rem;
    //    background: #ffffff;
    //    padding: 0.04rem 0.14rem;
    //    box-sizing: border-box;
    //    margin-bottom: 0.5rem;
    //    position: relative;
    //    .step-date {
    //      font-size: 0.12rem;
    //      height: 0.22rem;
    //    }
    //    .step-content {
    //      font-size: 0.14rem;
    //    }
    //  }
    //  .step-list::before {
    //    content: "";
    //    position: absolute;
    //  }
    //}
    .color8c8c8c {
      color: #8c8c8c;
    }
    .color434343 {
      color: #434343;
    }
    .bgEDF4FF {
      background-color: #edf4ff;
    }
  }
  .info-box {
    display: flex;
    flex-wrap: wrap;
    .info-box-list {
      margin-right: 0.2rem;
      margin-top: 0.2rem;
      .info-name {
        color: #8c8c8c;
        font-size: 0.12rem;
        line-height: 0.2rem;
        padding-bottom: 0.1rem;
        padding-top: 0.2rem;
      }
      .info-img {
        width: 1rem;
        height: 1rem;
        border-radius: 0.1rem;
      }
    }
  }
  .log-box {
    padding-top: 0.2rem;
  }
  .examine2-box {
    background-color: #f7fbff;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
  }
  .value-box {
    background-color: #f9f9f9;
    border-radius: 0.08rem;
    padding: 0.2rem;
    box-sizing: border-box;
    margin-top: 0.1rem;
  }
  .examine-box {
    padding-top: 0.1rem;
    .radio-box {
      margin-bottom: 0.2rem;
      margin-top: 0.1rem;
    }
  }
  .list-label {
    line-height: 0.12rem;
  }
}
</style>
